import styled from "styled-components";

export const StyledEditor = styled.div`
  & {
    .DraftEditor {
      height: 300px;
    }
  }
`;
